import { loadView } from '@/router'

export default [
  {
    path: 'pipes',
    name: 'sales-pipes',
    component: loadView('Application/Sales/Pipes')
  }
]
